/* All the global variables, mixins goes here */
@use "sass:math";
@import '../../../static/scss/resources/default.variables.scss';
@import '../../../static/scss/resources/default.style.scss';

.dashboard-icon {
    color: $color-brand;
}

.dashboard-container {
    padding-top: math.div($grid-gutter-width, 2);
    padding-bottom: math.div($grid-gutter-width, 2);
    min-height: 100%;
}

.dashboard-row {
    margin-bottom: math.div($grid-gutter-width, 2);
}

.graph-error {
    background-color: inherit;
    padding-top: 20px
}

.grid-error {
    background-color: $color-gray-lighter;
    padding-top: 20px;
    padding-bottom: 40px;
}

.grid-container {
    width: 100%;
    overflow: auto;
    border-radius: $card-border-radius;
    border: $panel-border;
}

.dashboard-link a {
    cursor: pointer;
    color: $color-fg;
}

.dashboard-graph {
    & .legend {
        font-size: $tree-font-size;
        & .legend-value {
            font-weight: normal;
            margin-left: 0.25rem;
            & .legend-label {
                margin-left: 0.25rem;
            }
        }
    }

    & .dashboard-graph-body {
        padding: 0.25rem 0.5rem;
        height: 165px;

        & .flotr-labels {
            color: $color-fg !important;
        }
        & .flotr-legend {
            border: none !important;
            padding: 0.25rem 0.5rem;
            & .flotr-legend-label {
                color: $color-fg !important;
                padding-left: 0.25rem;
            }

            & .flotr-legend-color-box>div {
                border: none !important;
                &>div {
                    border: none !important;
                }
            }

            & .flotr-legend-bg {
                border-radius: $border-radius;
            }
        }
    }
}

.welcome-logo {
    width: 400px;
    & .app-name {
        fill: $color-brand;
    }
    & .app-name-underline {
        stroke: $color-fg;
    }
    & .app-tagline {
        fill: $color-fg;
    }
}
